import { createApp } from 'vue';
import Auth from './Auth';
import store from './store';
import router from './router';
import 'bulma/css/bulma.css';

import App from './components/App.vue';

window.onGoogleApiLoad = async () => {
  const auth = new Auth({
    apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  });

  try {
    await auth.init();

    auth.addEventListener('loggedIn', () => {
      store.commit('auth/logIn');
      router.push('/spreadsheets');
    });

    auth.addEventListener('loggedOut', () => {
      store.commit('auth/logOut');
      router.push('/');
    });

    await store.dispatch('auth/loadInitialState');

    window.app = createApp(App)
      .use(store)
      .use(router)
      .mount('#app');
  } catch (error) {
    document.write(error.message);
  }
};
